import { Storage } from "@capacitor/storage";
import { ListePresta } from "../../Pages/modeHorsLigne/modeHorsLigne";

export async function deleteLocalStorage(type: string, setChange: any) {
    try {
        await Storage.remove({ key: type });
        setChange(undefined)
    } catch (error) {
        console.error(`Erreur lors de la suppression de la clé ${type} :`, error);
    }
};
export async function deleteSelectedLocalStorage(type: string, selectedItems: any[], setChange: any) {
    try {
        const storedData = await Storage.get({ key: type });
        if (storedData.value) {
            const data = JSON.parse(storedData.value);

            // Filtrer les éléments à garder
            const updatedData = data.filter((item: any) => {
                const isSelected = selectedItems.some((selected: ListePresta) =>
                    selected.pv_id === item.entete.pv_id && selected.dev_id === item.entete.dev_id
                );
                return !isSelected; // On garde uniquement les éléments qui ne sont PAS sélectionnés
            });

            // Mettre à jour le stockage
            await Storage.set({ key: type, value: JSON.stringify(updatedData) });

            // Mettre à jour l'état
            setChange(updatedData);
        }
    } catch (error) {
        console.error(`Erreur lors de la suppression des éléments sélectionnés de ${type} :`, error);
    }
}
